import { EpgDetailDataSource } from './EpgDetailDataSource';
import { EpgApi } from '../../../api/EpgApi';
import { EpgUtil } from '../../utility/EpgUtil';
import { Backend } from '../../../api/Backend';
import { ISeriesDetail } from '../../../api/models/AndromeTV.types';

export class ScheduleDetailDataSource extends EpgDetailDataSource {
  constructor(backend: Backend) {
    super(backend);
  }

  override load(scheduleId: string) {
    return Promise.all([EpgApi.schedule(this.backend, scheduleId), this.initChannels()]).then(([asset]) => {
      this.schedule = asset.schedule;
      if (asset.series?.title) {
        this.series = asset.series as ISeriesDetail;
      }
      this.season = asset.season;
      this.channel = this.channelsList?.find(item => item.channelId === this.schedule?.channel);

      const fromuntil = EpgUtil.epgFromUntil(this.backend);
      return EpgApi.program(
        this.backend,
        asset.program.id,
        fromuntil.from,
        fromuntil.until,
        this.backend.deviceProfile?.profile.catalog
      )
        .then(result => {
          this.program = result.program;

          //todo check adult
          return this.findRecordingForProgram();
        })
        .then(() => {
          return super.load(scheduleId);
        });
    });
  }
}
